<section class="news-section section-pad">
    <div class="container-fluid px-lg-5">
        <!-- Section Header -->
        <div class="text-center mb-5 animate-on-scroll fade-up">
            <span class="section-badge">Updates</span>
            <h2 class="section-title mt-3">Latest News & Events</h2>
            <div class="title-underline">
                <span class="line-segment"></span>
                <span class="line-segment accent"></span>
            </div>
        </div>

        <!-- Highlighted Hiring Callout Banner -->
        <div class="hiring-alert-card mb-5 animate-on-scroll fade-up stagger-1">
            <div class="alert-body">
                <div class="alert-info-left">
                    <div class="alert-header-wrap">
                        <div class="alert-icon-wrap">
                            <i class="fas fa-bullhorn alert-icon"></i>
                        </div>
                        <div class="alert-text-content">
                            <span class="alert-badge-tag text-uppercase">Recruitment Alert</span>
                            <h3 class="alert-message-title">Post of Lady Principal</h3>
                        </div>
                    </div>
                    <p class="alert-message-subtitle text-muted">
                        Applications are invited for the post of Lady Principal at Vaish Girls College, Samalkha.
                    </p>
                </div>

                <div class="alert-actions-right">
                    <!-- <a [href]="pdfUrl" target="_blank" class="btn-alert-action download-btn">
                         <i class="fas fa-file-pdf me-2"></i> Download PDF Form
                     </a> -->
                    <a [routerLink]="formsRoute" class="btn-alert-action apply-btn">
                        <i class="fas fa-paper-plane me-2"></i> Apply Online Now
                    </a>
                </div>
            </div>
        </div>

        <!-- News Content Grid -->
        <div class="row g-5">
            <!-- Left Side: Notice Board -->
            <div class="col-lg-5 animate-on-scroll fade-right">
                <div class="notice-board-wrap">
                    <div class="board-header">
                        <i class="fas fa-calendar-alt me-2"></i> Notice Board
                    </div>
                    <div class="board-body">
                        <!-- Active Notice 1 (Hiring Notice) -->
                        <!-- <div class="notice-item active-notice">
                            <div class="notice-date">
                                <span class="day">08</span>
                                <span class="month">Jun</span>
                            </div>
                            <div class="notice-details">
                                <h4 class="notice-title">Recruitment Notice: Principal</h4>
                                <p class="notice-desc text-muted">
                                    Applications are invited for the post of Principal. Apply online or download the
                                    form below.
                                </p>
                                <div class="notice-actions-row">
                                    <a [href]="pdfUrl" target="_blank" class="notice-link">
                                        Download PDF <i class="fas fa-download ms-1"></i>
                                    </a>
                                    <span class="action-divider">|</span>
                                    <a [routerLink]="formsRoute" class="notice-link apply-link">
                                        Apply Online <i class="fas fa-external-link-alt ms-1"></i>
                                    </a>
                                </div>
                            </div>
                        </div> -->

                        <!-- Dummy Notice 2 -->
                        <div class="notice-item">
                            <div class="notice-date">
                                <span class="day">15</span>
                                <span class="month">May</span>
                            </div>
                            <div class="notice-details">
                                <h4 class="notice-title">Admissions Open 2026-27</h4>
                                <p class="notice-desc text-muted">
                                    Admissions are now open for B.A., B.COM., M.A. and M.Com courses. Apply online.
                                </p>
                                <a href="https://admissions.highereduhry.ac.in/" target="_blank" class="notice-link">
                                    Apply Now <i class="fas fa-arrow-right ms-1"></i>
                                </a>
                            </div>
                        </div>

                        <!-- Dummy Notice 3 -->
                        <div class="notice-item">
                            <div class="notice-date">
                                <span class="day">02</span>
                                <span class="month">May</span>
                            </div>
                            <div class="notice-details">
                                <h4 class="notice-title">KUK Examination Forms</h4>
                                <p class="notice-desc text-muted">
                                    Online examination form submission link is active for the upcoming semester
                                    examinations.
                                </p>
                                <a href="https://examforms.kuk.ac.in/KukHome/AdminLogIn.aspx" target="_blank"
                                    class="notice-link">
                                    Submit Form <i class="fas fa-arrow-right ms-1"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Side: Latest News Cards (4 images with Lightbox) -->
            <div class="col-lg-7 animate-on-scroll fade-left">
                <div class="gallery-wrapper">
                    <h3 class="gallery-title-header"><i class="fas fa-newspaper me-2"></i> Latest News</h3>
                    <div class="news-gallery-grid mt-4">
                        <div *ngFor="let img of newsImages" class="gallery-card" (click)="openLightbox(img.src)">
                            <div class="gallery-img-wrap">
                                <img [src]="img.src" [alt]="img.title"
                                    onerror="this.src='https://placehold.co/400x300/e8e8e8/666666?text=Vaish+Girls+College'" />
                                <div class="gallery-overlay">
                                    <div class="zoom-icon"><i class="fas fa-search-plus"></i></div>
                                </div>
                            </div>
                            <div class="gallery-card-body">
                                <h4 class="card-news-title">{{ img.title }}</h4>
                                <p class="card-news-desc">{{ img.desc }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Custom Lightbox Modal -->
    <div class="custom-lightbox" *ngIf="isLightboxOpen" (click)="closeLightbox()">
        <span class="close-btn" (click)="closeLightbox()">&times;</span>
        <img [src]="selectedImageSrc" class="lightbox-img" (click)="$event.stopPropagation()" alt="News Zoomed" />
    </div>
</section>